import { AwardsMenu } from "@events-awards/utils/types";

export const siaFooterMenu = [
  {
    label: "About",
    link: "/events-awards/sustainability-impact-awards/about",
  },
  {
    label: "Awards",
    link: "/events-awards/sustainability-impact-awards/awards",
  },
  {
    label: "Winners",
    link: "/events-awards/sustainability-impact-awards/winners",
  },
  {
    label: "News",
    link: "/events-awards/sustainability-impact-awards/news",
  },
  {
    label: "How to Nominate",
    link: "/events-awards/sustainability-impact-awards/how-to-nominate",
  },
  {
    label: "Contact Us",
    link: "/events-awards/sustainability-impact-awards/contact-us",
  },
  {
    label: "Partners",
    link: "/events-awards/sustainability-impact-awards/partners",
  },
  {
    label: "Judges",
    link: "/events-awards/sustainability-impact-awards/judges",
  },
];

export const siaNavigationMenu: AwardsMenu[] = [
  {
    text: "About",
    link: "/events-awards/sustainability-impact-awards/about",
    enabled: true,
  },
  {
    text: "Awards",
    link: "/events-awards/sustainability-impact-awards/awards",
    enabled: true,
  },
  {
    text: "Winners",
    link: "/events-awards/sustainability-impact-awards/winners",
    enabled: true,
  },
  {
    text: "News",
    link: "/events-awards/sustainability-impact-awards/news",
    enabled: true,
  },
  {
    text: "Gallery",
    link: "/events-awards/sustainability-impact-awards/gallery",
    enabled: true,
  },
  {
    text: "How to Nominate",
    link: "/events-awards/sustainability-impact-awards/how-to-nominate",
    enabled: true,
  },
];

export const NominationTabs = [
  {
    key: "nominations",
    label: "Nominations",
  },
  {
    key: "assessment",
    label: "Assessment",
  },
  {
    key: "declarations",
    label: "Declarations",
  },
];
